import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { mobileNumber } from '@/Utils/fliter'

function getChangesRow (item, vm) {
  let residenceTh = []
  if (parseInt(item.application_type) === 1) {
    residenceTh = [
      { text: vm.$t('externalUser.total_residence'), bold: true, style: 'th', alignment: 'left' },
      { text: item.total_residence, style: 'td' },
      { text: vm.$t('externalUser.grant_application_no'), bold: true, style: 'th', alignment: 'left' },
      { text: vm.$n(item.grant_application_no), style: 'td' }
    ]
  } else {
    residenceTh = [
      { text: vm.$t('externalUser.total_residence'), bold: true, style: 'th', alignment: 'left' },
      { text: item.total_residence, style: 'td' },
      { text: vm.$t('externalUser.extension_request_no'), bold: true, style: 'th', alignment: 'left' },
      { text: vm.$n(item.extension_req_no), style: 'td' }
    ]
  }
  return residenceTh
}

// function getChangesRow1 (item, vm) {
//   let residenceTh = []
//   if (parseInt(item.application_type) === 1) {
//       residenceTh = [
//         { text: vm.$t('grant_registration.approved_qty'), bold: true, style: 'th', alignment: 'left' },
//         { text: item.approve_quantity ? vm.$n(item.approve_quantity) : 0, style: 'td', colSpan: '3' },
//         { },
//         { }
//       ]
//   } else {
//     residenceTh = [
//       { text: vm.$t('grant_registration.approved_qty'), bold: true, style: 'th', alignment: 'left' },
//       { text: item.approve_quantity ? vm.$n(item.approve_quantity) : '', style: 'td' },
//       { text: vm.$t('externalUser.capitation_grant_received'), bold: true, style: 'th', alignment: 'left' },
//       { text: vm.$n(item.grant_received), style: 'td' }
//     ]
//   }
//   return residenceTh
// }

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, profile, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                {},
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      pdfContent.push(
          { text: reportTitle, style: 'header', alignment: 'center', decoration: 'underline' }
      )
      const allRows = [
            [
              { text: vm.$t('externalUser.institute_info'), bold: true, style: 'th1', colSpan: '4', alignment: 'center' },
              { },
              { },
              { }
            ],
            [
              { text: vm.$t('institute_manangement.organization_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.org_name_bn : profile.org_name, style: 'td' },
              { text: vm.$t('externalUser.application_type'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.application_type_bn : profile.application_type_en, style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.institute_type'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getInstituteType(profile.ins_type), style: 'td' },
              { text: vm.$t('grant_registration.institution_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.ins_name_bn : profile.ins_name, style: 'td' }
            ],
            [
              { text: vm.$t('grant_config.service_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.service_type_bn : profile.service_type, style: 'td' },
              { text: vm.$t('grant_config.service_type'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.service_name_bn : profile.service_name, style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.address'), bold: true, style: 'th1', colSpan: '4', alignment: 'center' },
              { },
              { },
              { }
            ],
            [
              { text: vm.$t('hospital_public_panel.area_type'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAreaType(profile.area_type_id), style: 'td' },
              { text: vm.$t('hospital_public_panel.division'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getDivisionName(profile.division_id), style: 'td' }
            ],
            [
              { text: vm.$t('hospital_public_panel.district'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getDistrictName(profile.district_id), style: 'td' },
              { text: vm.$t('hospital_public_panel.upazila'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.upazila_id ? vm.getUpazilaName(profile.upazila_id) : 'N/A', style: 'td' }
            ],
            [
              { text: vm.$t('hospital_public_panel.city_corporation'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.city_corporation_id ? vm.getCityCorpName(profile.city_corporation_id) : 'N/A', style: 'td' },
              { text: vm.$t('hospital_public_panel.pourashava'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.paurasabha_id ? vm.getPourosobaName(profile.paurasabha_id) : 'N/A', style: 'td' }
            ],
            [
              { text: vm.$t('hospital_public_panel.union'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.union_id ? vm.getUnionName(profile.union_id) : 'N/A', style: 'td' },
              { text: vm.$t('org_pro.ward'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.ward_id ? vm.getWardName(profile.ward_id) : 'N/A', style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.address'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.address_bn : profile.address, style: 'td', colSpan: '3' },
              { },
              { }
            ],
            [
              { text: vm.$t('externalUser.respo_personal'), bold: true, style: 'th1', colSpan: '4', alignment: 'center' },
              { },
              { },
              { }
            ],
            [
              { text: vm.$t('globalTrans.name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.respo_name_bn : profile.respo_name_en, style: 'td' },
              { text: vm.$t('globalTrans.designation'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$i18n.locale === 'bn' ? profile.respo_designation_bn : profile.respo_designation_en, style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.nid_no'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.respo_nid, style: 'td' },
              { text: vm.$t('globalUserData.mobile_no'), bold: true, style: 'th', alignment: 'left' },
              { text: mobileNumber(profile.mobile_no), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.others'), bold: true, style: 'th1', colSpan: '4', alignment: 'center' },
              { },
              { },
              { }
            ],
            [
              { text: vm.$t('externalUser.office_type'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getOfficeType(profile.office_type_id), style: 'td' },
              { text: vm.$t('externalUser.office_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getOfficeName(profile.office_id), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.institution_registration_no'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.reg_no, style: 'td' },
              { text: vm.$t('externalUser.registration_date'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$d(new Date(profile.reg_date)), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.land_amount_and_source_of_receipt'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.land_amount, style: 'td' },
              { text: vm.$t('externalUser.arch'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getEstateName(profile.real_estate_id), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.type_wise_number_of_residence'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.$t('globalTrans.boy') + ' : ' + (profile.num_of_residence_male ? profile.num_of_residence_male : 0), style: 'th', alignment: 'left' },
              { text: vm.$t('globalTrans.girl') + ' : ' + (profile.num_of_residence_female ? profile.num_of_residence_female : 0), style: 'th', alignment: 'left' },
              { text: vm.$t('globalTrans.other') + ' : ' + (profile.num_of_residence_fixed ? profile.num_of_residence_fixed : 0), style: 'th', alignment: 'left' }
            ],
            getChangesRow(profile, vm),
            // getChangesRow1(profile, vm),
            [
              { text: vm.$t('externalUser.whether_the_resident_has_an_admission_register'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.admission_register), style: 'td' },
              { text: vm.$t('externalUser.whether_the_resident_has_an_leave_register'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.leave_register), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.whether_the_resident_has_an_attendance_register'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.attendance_register), style: 'td' },
              { text: vm.$t('externalUser.recorded_bill_voucher'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.bill_voucher), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.last_fiscal_year_audit'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.fis_year_audit), style: 'td' },
              { text: vm.$t('externalUser.last_committee_approval'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.getAnswerName(profile.committee_approval), style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.last_committee_approval_date'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.committee_approval_date ? vm.$d(new Date(profile.committee_approval_date)) : '', style: 'td' },
              { text: vm.$t('externalUser.bank_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.bankName, style: 'td' }
            ],
            [
              { text: vm.$t('externalUser.branch_name'), bold: true, style: 'th', alignment: 'left' },
              { text: vm.branchName, style: 'td' },
              { text: vm.$t('externalUser.account_no'), bold: true, style: 'th', alignment: 'left' },
              { text: profile.acc_no, style: 'td' }
            ]
      ]
        pdfContent.push({
            table: {
            headerRows: 0,
            widths: '*',
            body: allRows
            }
        })
        const Blank2 = [
          {},
          {}
        ]
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['100%'],
            body: Blank2
          }
        })
        if (profile.documents.length > 0) {
            const allRowsHead = [
              [
                { text: vm.$t('externalUser.documents'), colSpan: 3, style: 'th1', alignment: 'center' },
                {},
                {}
              ],
              [
                { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
                { text: vm.$t('grant_registration.document_title'), style: 'th', alignment: 'center' },
                { text: vm.$t('externalUser.comments'), style: 'th', alignment: 'center' }
              ]
            ]
            profile.documents.map((item, index) => {
              allRowsHead.push(
              [
                { text: vm.$n(index + 1), style: 'td', alignment: 'center' },
                { text: item.title, style: 'td', alignment: 'center' },
                { text: vm.$i18n.locale === 'bn' ? item.comment_bn : item.comment, style: 'td', alignment: 'center' }
              ])
            })
            pdfContent.push({
              table: {
                headerRows: 1,
                widths: '33.33%',
                body: allRowsHead
              }
            })
        }
        var docDefinition = {
          content: pdfContent,
          pageSize: 'A4',
          pageOrientation: 'portrait',
          styles: {
            th: {
              border: 0,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            th1: {
              fillColor: '#dee2e6',
              border: 0,
              fontSize: 12,
              margin: [3, 3, 3, 3]
            },
            td: {
              border: 1,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            td2: {
                border: 0,
                fontSize: 10,
                alignment: 'center'
              },
            oderDetails: {
              border: true,
              fontSize: 14
            },
            left_header: {
              margin: [4, 0, 0, 10]
            },
            header: {
              margin: [0, 10, 0, 10],
              fontSize: 14,
              alignment: 'center'
            },
            header2: {
              border: 0,
              fontSize: 14,
              margin: [0, 0, 0, 1]
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
                border: 0,
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 1]
            },
            address2: {
              border: 0,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 1]
            },
            left_logo: {
              border: 0,
              margin: [5, 0, 0, 5]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
      }
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
